<template>
  <div>
    <div class="search-bar">
      <div>Search</div>
      <div class="">
        <input
          v-model="filters.hanzi"
          type="text"
          name="hanzi"
          placeholder="Hanzi"
        />
      </div>
      <div class="">
        <input
          v-model="filters.unicode"
          type="number"
          name="unicode"
          placeholder="Unicode"
        />
      </div>
      <div class="">
        <input
          v-model="filters.radical"
          type="text"
          name="radical"
          placeholder="Radical"
        />
      </div>
      <div class="col-span-3">
        <span
          @click="
            filters.layout != 'NL00'
              ? (filters.layout = 'NL00')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL00' }"
          class="NL"
        ></span>
        <span
          @click="
            filters.layout != 'NL01'
              ? (filters.layout = 'NL01')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL01' }"
          class="NL NL01"
        ></span>
        <span
          @click="
            filters.layout != 'NL02'
              ? (filters.layout = 'NL02')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL02' }"
          class="NL NL02"
        ></span>
        <span
          @click="
            filters.layout != 'NL03'
              ? (filters.layout = 'NL03')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL03' }"
          class="NL NL03"
        ></span>
        <span
          @click="
            filters.layout != 'NL04'
              ? (filters.layout = 'NL04')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL04' }"
          class="NL NL04"
        ></span>
        <span
          @click="
            filters.layout != 'NL05'
              ? (filters.layout = 'NL05')
              : (filters.layout = null)
          "
          :class="{ active: filters.layout == 'NL05' }"
          class="NL NL05"
        ></span>
      </div>
      <div class="flex">
        <input
          type="submit"
          name="submit"
          @click="loadDatabase"
          value="Apply"
        />
      </div>
      <div class="col-span-2">{{ data.length }} of {{ count }}</div>
    </div>
    <div class="database">
      <div class="header row">
        <div>ID</div>
        <div>Hanzi</div>
        <div></div>
        <div>Unicode</div>
        <div>Radical</div>
        <div>Layout</div>
        <div>Box0</div>
        <div>Box1</div>
        <div>Box2</div>
        <div>Nested</div>
      </div>
      <div v-for="symbol in data" :key="symbol.HanziID" class="row">
        <div>{{ symbol.HanziID | format }}</div>
        <div class="hanzi" :data-text="symbol.Hanzi">{{ symbol.Hanzi }}</div>
        <div></div>
        <div>{{ symbol.Unicode }}</div>
        <div>{{ symbol.Radical }}</div>
        <div class="relative">
          <span class="NL SMALL" :class="symbol.LayoutID"></span>
        </div>
        <div>
          <span
            v-if="symbol.Box0.match(/[a-zA-Z]/)"
            class="NL SMALL"
            :class="symbol.Box0"
          ></span>
          <span v-else>
            {{ symbol.Box0 }}
          </span>
        </div>
        <div>
          <span
            v-if="symbol.Box1.match(/[a-zA-Z]/)"
            class="NL SMALL"
            :class="symbol.Box1"
          ></span>
          <span v-else>
            {{ symbol.Box1 }}
          </span>
        </div>
        <div>
          <span
            v-if="symbol.Box2.match(/[a-zA-Z]/)"
            class="NL SMALL"
            :class="symbol.Box2"
          ></span>
          <span v-else>
            {{ symbol.Box2 }}
          </span>
        </div>
        <div>{{ symbol.Nested | nested }}</div>
      </div>
    </div>
    <div class="pad flex">
      <input type="submit" name="submit" @click="loadMore" value="Load more" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};
export default {
  name: "database",
  metaInfo() {
    return {
      title: "– Database",
    };
  },
  data() {
    return {
      data: [],
      count: 0,
      filters: {
        hanzi: null,
        radical: null,
        layout: null,
        unicode: null,
        page: 0,
      },
    };
  },
  created() {
    this.loadDatabase();
    this.loadCount();
  },
  methods: {
    loadCount() {
      axios.post("/api/count", {}, { auth }).then((result) => {
        this.count = result.data;
      });
    },
    loadDatabase() {
      let query = this.filters;
      query.page = 0;
      axios
        .post(
          "/api/db",
          {
            query,
          },
          { auth }
        )
        .then((result) => {
          this.data = result.data;
          let val = result.data[result.data.length - 1].HanziID;
          this.filters.page = parseInt(val.replace(/\.0$/, "")) + 1;
        });
    },
    loadMore() {
      let query = this.filters;
      axios
        .post(
          "/api/db",
          {
            query,
          },
          { auth }
        )
        .then((result) => {
          for (let i = 0; i < result.data.length; i++) {
            this.data.push(result.data[i]);
          }
          let val = result.data[result.data.length - 1].HanziID;
          this.filters.page = parseInt(val.replace(/\.0$/, "")) + 1;
        });
    },
  },
  filters: {
    format(val) {
      if (val) {
        val = val.replace(/\.0$/, "");
        return val;
      }
    },
    nested(val) {
      if(val == "1.0") {
        return "Yes";
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.relative {
  position: relative;
  z-index: 0;
}
input {
  appearance: none;
  border-radius: 0;
  border: 1px solid black;
  background: white;
  outline: none;
  font-size: var(--fs);
  line-height: 1;
  &[type="number"],
  &[type="text"],
  &[type="submit"] {
    width: 100%;
    // margin-bottom: 0.25rem;
    padding: 0.5rem;
    transition: border 0.3s, color 0.3s;
  }
  &[type="submit"]:hover {
    border-color: rgb(200, 200, 200);
    color: rgb(200, 200, 200);
    cursor: pointer;
  }
}
.NL {
  display: inline-block;
  width: 2.1rem;
  height: 2.1rem;
  border: 1px solid black;
  margin-right: 1rem;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  transition: border 0.3s;
  &.SMALL {
    width: 1.2rem;
    height: 1.2rem;
  }
  &:before,
  &:after {
    transition: border 0.3s;
  }
  &:hover,
  &.active {
    border-color: rgb(200, 200, 200);
    &:before,
    &:after {
      border-color: rgb(200, 200, 200);
    }
  }
}
.NL01:before {
  content: "";
  position: absolute;
  top: 0;
  left: calc(50% - 1px);
  width: 1px;
  height: 100%;
  border-right: 1px solid black;
}
.NL02:before {
  content: "";
  position: absolute;
  left: 0;
  top: calc(50% - 1px);
  height: 1px;
  width: 100%;
  border-bottom: 1px solid black;
}
.NL03:before {
  content: "";
  position: absolute;
  left: 15%;
  top: 15%;
  bottom: 15%;
  right: 15%;
  border: 1px solid black;
}
.nl04:before {
  content: "";
  position: absolute;
  top: 0;
  left: calc(33.3% - 1px);
  width: 1px;
  height: 100%;
  border-right: 1px solid black;
}
.NL04:after {
  content: "";
  position: absolute;
  top: 0;
  left: calc(66.67% - 1px);
  width: 1px;
  height: 100%;
  border-right: 1px solid black;
}
.NL05:before {
  content: "";
  position: absolute;
  left: 0;
  top: calc(33.3% - 1px);
  height: 1px;
  width: 100%;
  border-bottom: 1px solid black;
}
.NL05:after {
  content: "";
  position: absolute;
  left: 0;
  top: calc(66.7% - 1px);
  height: 1px;
  width: 100%;
  border-bottom: 1px solid black;
}
.col-span-2 {
  grid-column: span 2;
}
.col-span-3 {
  grid-column: span 3;
}
.col-span-4 {
  grid-column: span 5;
}
.search-bar {
  border-bottom: 1px solid black;
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  padding: 0.5rem 0;
  align-items: center;
  > div {
    padding: 0 0.5rem;
    &:first-of-type {
      padding-left: var(--lh);
    }
    &:last-of-type {
      padding-right: var(--lh);
    }
  }
  @media only screen and (max-width: 768px) {
    grid-gap: 0.5rem 0;
    grid-template-columns: repeat(4, 1fr);
    padding: var(--lh);
    > div {
      padding: 0;
      grid-column: span 4;
      &:first-of-type {
        display: none;
      }
      &:first-of-type,
      &:last-of-type {
        padding: 0;
      }
    }
  }
}
.database {
  .row {
    padding: 0.5rem 0;
    display: grid;
    grid-template-columns: repeat(10, 1fr);
    border-bottom: 1px solid black;

    &:hover {
      background: rgba(0, 0, 0, 0.1);
      .hanzi {
        position: relative;
        &:before {
          content: attr(data-text);
          position: absolute;
          background: black;
          color: white;
          top: 50%;
          left: 2rem;
          transform: translate(0.5rem, -50%);
          padding: 1rem;
          padding-top: 0.5rem;
          // padding-bottom: 0.4rem;
          font-size: 6rem;
          line-height: 1.2;
          pointer-events: none;
          z-index: 3;
        }
      }
    }
    > div {
      padding: 0 0.5rem;
      &:first-of-type {
        padding-left: var(--lh);
      }
      &:last-of-type {
        padding-right: var(--lh);
      }
    }
  }
  .header {
    position: sticky;
    top: calc(0 * var(--lh));
    background: white;
    z-index: 2;
    &:hover {
      background: white;
    }
  }
}
</style>
